import "core-js/stable";
import {AdditionalProductFeatures} from "./resources/js/shortcodes/AdditionalProductFeatures";
import {HsFormCfComponent} from './resources/js/components/HsFormCfComponent';
import './resources/sass/app.scss';

document.addEventListener('DOMContentLoaded', () => {
    const additionalProductFeatures = new AdditionalProductFeatures();
    const hsFormCfComponent = new HsFormCfComponent('.contact-form .hs-form');
    hsFormCfComponent.initialize();
});
